export const state = {
    gradeProduto: {},
    gradesProduto: [],
    modalCadastroGradeProduto: false,
    modalExcluirGradeProduto: false,
    modalListarGradeProduto: false,
}

export default {}